import React from 'react'

const Social = () => {
  return (
    <div className="home__social">
        <a href="https://instagram.com/adityaa.shukla?igshid=MTk0NTkyODZkYg==" className="home__social-icon" target="_blank">
            <i className="uil uil-instagram"></i>
        </a>
        {/* <a href="https://twitter.com/Yash_agarwal02" className="home__social-icon" target="_blank">
            <i className="uil uil-twitter-alt"></i>
        </a> */}
        <a href="http://www.linkedin.com/in/aditya-shukla07" className="home__social-icon" target="_blank">
            <i className="uil uil-linkedin"></i>
        </a>
        <a href="https://github.com/adityaashuklaa" className="home__social-icon" target="_blank">
            <i className="uil uil-github-alt"></i>
        </a>
    </div>
  )
}

export default Social